<template>
  <div class="card table-card task-expenses-table-card">
    <div class="card-body">
      <!--  TODO: Вынести тулбар в отдельный компонент, применить к другим таблицам  -->
      <div class="table-toolbar">
        <div class="toolbar-options">
          <div
            v-for="option in toolbarOptions"
            :key="option.name"
            class="toolbar-options__item"
            :class="{active: option.name === activeToolbarOption}"
            @click="() => handleToolbarItemClick(option.name)">
            <div class="toolbar-options__item-icon">
              <i :class="option.icon"/>
            </div>
            <div v-if="option.textRows.length" class="toolbar-options__item-text">
              <p v-for="(row, index) in option.textRows" :key="index">
                {{ row }}
              </p>
            </div>
          </div>
        </div>
        <div class="toolbar-buttons">
          <div
            v-for="btn in toolbarButtons"
            :key="btn.icon"
            class="toolbar-buttons__item">
            <p-button
              outline
              @click="btn.handler">
              <i :class="btn.icon"/>
              <span>{{ btn.text }}</span>
            </p-button>
          </div>
        </div>
        <transition v-if="activeToolbarOption" appear name="fade">
          <div class="settings-panel">
            <component
              :is="option.component"
              v-for="option in toolbarOptions"
              v-show="activeToolbarOption === option.name"
              :key="option.name"
              v-model="toolbarModel[option.name]"
              :panel-props="getSettingsPanelProps(option.name)"/>
            <el-tooltip
              :disabled="!activeToolbarOption"
              placement="top"
              :open-delay="500"
              content="Скрыть панель настроек">
              <p-button
                icon
                round
                size="sm"
                class="settings-close-btn"
                @click="handleClickCloseSettingsPanel">
                <el-icon>
                  <Close/>
                </el-icon>
              </p-button>
            </el-tooltip>
          </div>
        </transition>
      </div>

      <div class="task-expenses-table">
        <el-table
          v-if="showTable"
          v-loading="loading"
          :border="false"
          :data="taskExpensesList"
          show-summary
          :summary-method="getSummaries"
          element-loading-background="rgba(255, 255, 255, 0.6)"
          :empty-text="loading ? 'Обновление данных...' : 'Информация не найдена'"
          header-cell-class-name="table__header-cell">
          <el-table-column label="Дата" align="center">
            <template #default="scope">
              {{ getDate(scope.row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column label="Кол-во выполненных задач" prop="count_tasks" align="center"/>
          <el-table-column label="Сумма выводов без комиссии" prop="withdrawal_amount" align="center"/>
          <el-table-column label="Комиссия" align="center">
            <template #default="scope">
              {{ Number(scope.row.partner_commission).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="Сумма выводов с комиссией" align="center">
            <template #default="scope">
              {{ (Number(scope.row.withdrawal_amount) + Number(scope.row.partner_commission)).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="Марафон" prop="marathon_amount" align="center"/>
        </el-table>
        <div v-else class="task-expenses-table__dummy">
          <i class="fa fa-calendar"/>
          Выберите расчетный период
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ElTooltip } from 'element-plus'
import TableFilters from '@/components/UIComponents/Custom/TaskToolbar/TableFilters'
import TableDateRange from '@/components/UIComponents/Custom/TaskToolbar/TableDateRange'
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'TaskExpenses',
  components: {
    ElTooltip
  },
  data() {
    return {
      loading: false,
      toolbarModel: {
        dateRange: [],
        filter: {
          role: 'all',
          taskType: 'all'
        }
      },
      activeToolbarOption: 'dateRange',
      toolbarOptions: [
        {
          name: 'dateRange',
          icon: 'fa fa-calendar',
          textRows: [],
          component: TableDateRange
        },
        {
          name: 'filter',
          icon: 'fa fa-filter',
          textRows: [],
          component: TableFilters
        }
        /*
                {
                  name: 'search',
                  icon: 'fa fa-search',
                  textRows: [
                    'Строка 1',
                    'Строка 2 подлиннее',
                  ],
                  component: TableSearch,
                  value: '',
                },
        */
      ],
      toolbarButtons: [
        /*
                {
                  icon: 'fa fa-plus',
                  text: 'добавить',
                  handler: () => console.log('добавить')
                },
                {
                  icon: 'fa fa-minus',
                  text: 'убавить',
                  handler: () => console.log('убавить')
                },
        */
      ]
    }
  },
  computed: {
    ...mapGetters({
      taskExpensesList: 'superadministrator/taskExpensesList'
    }),
    settingsPanelPropsAll() {
      return {
        filter: {
          filters: [
            {
              criterion: 'role',
              label: 'Роль пользователя',
              show: true,
              options: [
                {
                  value: 'all',
                  label: 'Все роли'
                },
                {
                  value: 'uploader',
                  label: 'Паблишер'
                },
                {
                  value: 'uidesigner',
                  label: 'UX/UI-дизайнер'
                },
                {
                  value: 'designer',
                  label: 'Дизайнер'
                },
                {
                  value: 'programmer',
                  label: 'Разработчик'
                },
                {
                  value: 'uidesigner+designer+programmer',
                  label: 'UX/UI-дизайнер, Дизайнер, Разработчик'
                }
              ]
            },
            {
              criterion: 'taskType',
              label: 'Тип задачи',
              show: this.toolbarModel.filter.role === 'uploader',
              options: [
                {
                  value: 'all',
                  label: 'Все типы'
                },
                {
                  value: 'publish',
                  label: 'Публикация'
                },
                {
                  value: 'update',
                  label: 'Обновление'
                }
              ]
            }
          ]
        }
      }
    },
    showTable() {
      const dateRange = this.toolbarModel.dateRange
      return dateRange && dateRange.length === 2 && dateRange.every(item => !!item)
    }
  },
  watch: {
    'toolbarModel.filter': {
      deep: true,
      handler(filter) {
        if (filter.role !== 'uploader' && filter.taskType !== 'all') {
          this.toolbarModel.filter.taskType = 'all'
          return
        }
        const textRows = []
        for (const [key, value] of Object.entries(filter)) {
          if (value === 'all') continue
          const filterObject = this.settingsPanelPropsAll.filter.filters.find(item => item.criterion === key)
          const label = filterObject.label
          const currentValue = filterObject.options.find(item => item.value === value).label
          textRows.push(`${label}: ${currentValue}`)
        }
        this.toolbarOptions.find(item => item.name === 'filter').textRows = textRows
        this.downloadExpensesList()
      }
    },
    'toolbarModel.dateRange': {
      deep: true,
      handler(array, oldArray) {
        if (!this.showTable) return
        const startDate = moment(array[0])
          .format('DD.MM.yyyy')
        const endDate = moment(array[1])
          .format('DD.MM.yyyy')
        const oldStartDate = moment(oldArray[0])
          .format('DD.MM.yyyy')
        const oldSendDate = moment(oldArray[1])
          .format('DD.MM.yyyy')
        if (startDate === oldStartDate && endDate === oldSendDate) return
        const rangeString = `${startDate} - ${endDate}`
        this.toolbarOptions.find(item => item.name === 'dateRange').textRows = [rangeString]
        this.downloadExpensesList()
      }
    }
  },
  methods: {
    ...mapMutations({
      setTaskExpensesList: 'superadministrator/setTaskExpensesList'
    }),
    ...mapActions({
      downloadTaskExpensesList: 'superadministrator/downloadTaskExpensesList'
    }),
    async downloadExpensesList() {
      if (!this.showTable) return
      this.loading = true
      try {
        await this.downloadTaskExpensesList(this.toolbarModel)
      } finally {
        this.loading = false
      }
    },
    handleToolbarItemClick(name) {
      const alreadySelected = this.activeToolbarOption === name
      this.activeToolbarOption = alreadySelected ? undefined : name
    },
    handleClickCloseSettingsPanel() {
      this.activeToolbarOption = undefined
    },
    getSettingsPanelProps(name) {
      return this.settingsPanelPropsAll[name]
    },
    getDate(date) {
      return moment(date)
        .format('DD.MM.yyyy')
    },
    getSummaries(param) {
      const { columns, data } = param
      const result = ['Итого:']
      columns.map((column, index) => {
        if (index === 0) return
        if (column.property) {
          let summ = 0
          for (const item of data) {
            summ += Number(item[column.property])
          }
          result[index] = summ
        } else {
          let summ = 0
          for (const item of data) {
            if (column.label === 'Комиссия') {
              summ += Number(item.partner_commission)
            } else if (column.label === 'Сумма выводов с комиссией') {
              summ += Number(item.withdrawal_amount) + Number(item.partner_commission)
            }
          }
          result[index] = summ.toFixed(2)
        }
      })
      return result
    }
  },
  beforeUnmount() {
    this.setTaskExpensesList([])
  }
}
</script>

<style scoped>
</style>
